import {ComponentType, createContext, useContext} from 'react';
import {
  Conversation,
  ConversationMessage,
  AttachmentConversationMessage,
  ButtonOptionsConversationMessage,
  ArticlesConversationMessage,
  ButtonsConversationMessage,
  SelectOptionsConversationMessage,
  TextConversationMessage,
  InlineDataConversationMessage,
  RichTextConversationMessage,
  AgentCall,
} from '@stripe-internal/conversations-client';

export interface MessageComponentProps {
  conversation: Conversation;
  message: ConversationMessage;
  animated?: boolean;
  disableInteraction?: boolean;
  avatar?: React.ReactNode;
}

export interface MessageComponentRegistry {
  'attachment-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: AttachmentConversationMessage;
    }
  >;
  'select-options-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: SelectOptionsConversationMessage;
    }
  >;
  'button-options-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: ButtonOptionsConversationMessage;
    }
  >;
  'articles-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: ArticlesConversationMessage;
    }
  >;
  'buttons-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: ButtonsConversationMessage;
    }
  >;
  'text-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: TextConversationMessage;
    }
  >;
  'inline-data-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: InlineDataConversationMessage;
    }
  >;
  'rich-text-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: RichTextConversationMessage;
    }
  >;
  'tool-call'?: ComponentType<{
    conversation?: Conversation;
    agentCall: AgentCall;
    messageId: string;
  }>;
}

export const MessageComponentContext = createContext<MessageComponentRegistry>(
  {},
);

export function useMessageComponents() {
  return useContext(MessageComponentContext);
}
